import { Injectable, inject } from '@angular/core';

import { FsApi, RequestConfig } from '@firestitch/api';

import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class EnvironmentAclRoleData {
  private _api = inject(FsApi);


  public save(environmentId: number, data): Observable<any> {
    if (data.id) {
      return this.put(environmentId, data);
    }

    return this.post(environmentId, data);
  }

  public permissions(environmentId: number): Observable<any> {
    return this._api.get(`environments/${environmentId}/acl/config`, {}, { key: 'permissions' });
  }

  public levels(environmentId: number): Observable<any> {
    return this._api.get(`environments/${environmentId}/acl/config`, {}, { key: 'levels' });
  }

  public get(environmentId: number, id, data = {}): Observable<any> {
    return this._api.get(`environments/${environmentId}/acl/roles/${id}`, data, { key: 'aclRole' });
  }

  public gets(environmentId: number, data = {}, config: RequestConfig = {}): Observable<any> {
    return this._api.request('GET', `environments/${environmentId}/acl/roles`, data, { key: 'aclRoles', ...config });
  }

  public put(environmentId: number, data, config: RequestConfig = {}): Observable<any> {
    return this._api.put(`environments/${environmentId}/acl/roles/${data.id}`, data, { key: 'aclRole', ...config });
  }

  public post(environmentId: number, data): Observable<any> {
    return this._api.post(`environments/${environmentId}/acl/roles`, data, { key: 'aclRole' });
  }

  public delete(environmentId: number, data): Observable<any> {
    return this._api.delete(`environments/${environmentId}/acl/roles/${data.id}`, data, { key: 'aclRole' });
  }
}
